import StatusText from './StatusText';

export default StatusText;
